<template>
  <main class="w-full flex-grow p-6">
    <button
      @click="showModalCreate"
      class="block px-3 h-9 hover:text-white focus:ring focus:ring-primary-default focus:ring-opacity-30 focus:outline-none rounded-md text-sm bg-app-default hover:bg-app-light text-white mb-3 font-bold"
    >
      Add New Facility
    </button>

    <div class="mt-2 mb-5">
      <table class="w-full mx-auto table-auto">
        <thead class="justify-between">
          <tr class="bg-gray-600">
            <th class="px-5 py-2">
              <span class="text-gray-100 font-semibold">No</span>
            </th>
            <th class="px-16 py-2">
              <span class="text-gray-100 font-semibold">Title</span>
            </th>
            <th class="px-16 py-2">
              <span class="text-gray-100 font-semibold">Small</span>
            </th>
            <th class="px-16 py-2">
              <span class="text-gray-100 font-semibold">Large</span>
            </th>
            <th class="px-16 py-2">
              <span class="text-gray-100 font-semibold">Options</span>
            </th>
          </tr>
        </thead>
        <tbody class="bg-gray-200">
          <tr
            v-for="(sos, index) in rows"
            :key="sos.id"
            :class="[index % 2 !== 0 ? 'bg-gray-200' : '']"
            class="bg-white border-b-2 border-gray-200"
          >
            <td class="px-5 py-2 text-center">
              {{ index + 1 }}
            </td>
            <td class="text-center">
              <span class="font-semibold">
                {{ sos.title }}
              </span>
            </td>
            <td class="p-2">
              <div class="flex items-center justify-center">
                <img
                  class="w-10 h-10 cursor-pointer"
                  @click="showModal(sos.carousel_small)"
                  :src="sos.carousel_small"
                  alt="23paskal"
                />
              </div>
            </td>
            <td class="p-2">
              <div class="flex items-center justify-center">
                <img
                  class="w-10 h-10 cursor-pointer"
                  @click="showModal(sos.carousel_large)"
                  :src="sos.carousel_large"
                  alt="23paskal"
                />
              </div>
            </td>
            <td class="">
              <div class="flex items-center justify-evenly">
                <button class="" type="button" @click="detailContent(sos.id)">
                  <span class="font-bold text-app-default">
                    More
                  </span>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- modal create carousel -->
    <div
      v-if="modalCreate"
      class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed"
    >
      <div
        class="z-50 relative p-3 mx-auto my-0 max-w-full"
        style="width: 900px;"
      >
        <div
          class="bg-white rounded shadow-lg border flex flex-col overflow-hidden"
        >
          <div class="flex flex-row border-b items-center justify-between">
            <div class="px-6 py-3 text-xl font-bold">{{ title }}</div>
            <div class="">
              <button
                @click.self="closeModalCreate"
                class="font-3xl font-bold p-6"
              >
                &times;
              </button>
            </div>
          </div>
          <div class="p-6 flex-grow">
            <div class="flex flex-wrap">
              <div class="w-full pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80">Title</label>
                <input
                  v-model="create.title"
                  @keyup="titleChange"
                  type="text"
                  class="w-full h-9 px-2 rounded-md border-2 focus:outline-none focus:ring transition duration-200"
                  :class="[
                    errors.title
                      ? 'border-red-400 focus:ring-red-200'
                      : 'border-gray-200 focus:ring-blue-200',
                  ]"
                  placeholder="Title"
                />
                <div class="text-sm text-red-600 mb-5">
                  {{ errors.title_msg }}
                </div>
              </div>
              <div class="w-full pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80"
                  >Description</label
                >
                <textarea
                  v-model="create.description"
                  @keyup="descriptionChange"
                  rows="5"
                  class="w-full pl-3 pr-3 py-2 rounded-md border-2 focus:outline-none focus:ring transition duration-200"
                  :class="[
                    errors.description
                      ? 'border-red-400 focus:ring-red-200'
                      : 'border-gray-200 focus:ring-blue-200',
                  ]"
                  placeholder="Description"
                >
                </textarea>
                <div
                  class="text-right text-sm "
                  :class="[
                    create?.description?.length <= 2000
                      ? 'text-gray-600'
                      : 'text-red-600',
                  ]"
                >
                  {{ create?.description?.length }} used out of 2000 characters
                </div>
                <div class="text-sm text-red-600 mb-5">
                  {{ errors.description_msg }}
                </div>
              </div>
            </div>
            <label class="font-semibold text-black opacity-80"
              >Image Small (portrait: 1170 px X 1080 px)</label
            >
            <div class="w-80">
              <div
                class="border-dotted border-2 p-2 rounded-lg"
                :class="[
                  errors.carousel_small ? 'border-red-400' : 'border-black',
                ]"
                @drop="previewFileSmall"
              >
                <input
                  type="file"
                  accept="image/*"
                  @change="previewFileSmall"
                  id="carousel_file_small"
                  class="opacity-0 hidden"
                />
                <div class="flex flex-row">
                  <div
                    v-if="create.previewCarouselSmall"
                    class="mr-1 relative rounded-lg w-full"
                  >
                    <button
                      class="absolute right-2 top-2"
                      type="button"
                      @click="removeFileCarouselSmall()"
                    >
                      <fas icon="trash-alt" class="text-red-600 text-3xl" />
                    </button>
                    <img
                      :src="create.previewCarouselSmall"
                      class="w-full h-80 rounded-lg"
                    />
                  </div>
                  <div
                    v-if="create.previewCarouselSmall === null"
                    v-cloak
                    @click="chooseSmallFile()"
                    class="w-full h-80 mr-1 rounded-lg cursor-pointer bg-gray-200 flex items-center justify-center"
                  >
                    <fas icon="image" class="text-gray-600 text-3xl" />
                  </div>
                </div>
              </div>
              <div class="text-sm text-red-600 mb-5">
                {{ errors.carousel_small_msg }}
              </div>
            </div>

            <label class="font-semibold text-black opacity-80"
              >Image Large (landscape: 2560 px X 1347 px)</label
            >
            <div class="">
              <div
                class="border-dotted border-2 p-2 rounded-lg"
                :class="[
                  errors.carousel_large ? 'border-red-400' : 'border-black',
                ]"
                @drop="previewFileLarge"
              >
                <input
                  type="file"
                  accept="image/*"
                  @change="previewFileLarge"
                  id="carousel_file_large"
                  class="opacity-0 hidden"
                />
                <div class="flex flex-row">
                  <div
                    v-if="create.previewCarouselLarge"
                    class="mr-1 relative rounded-lg w-full"
                  >
                    <button
                      class="absolute right-2 top-2"
                      type="button"
                      @click="removeFileCarouselLarge()"
                    >
                      <fas icon="trash-alt" class="text-red-600 text-3xl" />
                    </button>
                    <img
                      :src="create.previewCarouselLarge"
                      class="w-full h-80 rounded-lg"
                    />
                  </div>
                  <div
                    v-if="create.previewCarouselLarge === null"
                    v-cloak
                    @click="chooseLargeFile()"
                    class="w-full h-80 mr-1 rounded-lg cursor-pointer bg-gray-200 flex items-center justify-center"
                  >
                    <fas icon="image" class="text-gray-600 text-3xl" />
                  </div>
                </div>
              </div>
              <div class="text-sm text-red-600 mb-5">
                {{ errors.carousel_large_msg }}
              </div>
            </div>
          </div>
          <div class="px-6 py-3 border-t">
            <div class="flex justify-end">
              <button
                @click.self="closeModalCreate"
                type="button"
                class="bg-gray-700 text-gray-100 rounded px-4 py-2 mr-1"
              >
                Close
              </button>
              <button
                @click.self="saveCarousel"
                type="button"
                class="bg-blue-600 text-gray-200 rounded px-4 py-2 w-32"
              >
                {{ saveButton }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        @click.self="closeModalCreate"
        class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-black opacity-50"
      ></div>
    </div>
    <Modal v-show="isModalVisible" @close="closeModal" :imageso="imageso" />
    <Warning />
    <SuccessNotif />
  </main>
</template>

<script>
import API from "../../api";
import Modal from "../../components/Modal.vue";
import Warning from "../../components/Warning.vue";
import SuccessNotif from "../../components/SuccessNotif.vue";
export default {
  name: "Table",
  components: {
    Modal,
    Warning,
    SuccessNotif,
  },
  data() {
    return {
      imageso: "",
      isModalVisible: false,
      preview: null,
      image: null,
      preview_list: [],
      image_list: [],
      modalCreate: false,
      title: "",
      actionType: null,
      errors: {
        carousel_small: false,
        carousel_small_msg: "",
        carousel_large: false,
        carousel_large_msg: "",
        title: false,
        title_msg: "",
        description: false,
        description_msg: "",
      },
      create: {
        title: "",
        description: "",
        previewCarouselSmall: null,
        imageCarouselSmall: null,
        previewCarouselLarge: null,
        imageCarouselLarge: null,
      },
      rows: [],
      id: null,
      saveButton: "Save",
      deleteButton: "Delete",
    };
  },
  methods: {
    showModal: function(data) {
      this.imageso = data;
      this.isModalVisible = true;
    },
    closeModal: function() {
      this.isModalVisible = false;
    },
    detailContent: function(id) {
      this.$router.push(this.$route.path + "/" + id);
    },
    titleChange: function(e) {
      this.create.title = e.target.value;
      this.errors.title = false;
      this.errors.title_msg = "";
    },
    descriptionChange: function(e) {
      this.create.description = e.target.value;
      this.errors.description = false;
      this.errors.description_msg = "";
    },
    chooseSmallFile: function() {
      document.getElementById("carousel_file_small").click();
    },
    previewFileSmall: function(event) {
      let input = event.target;
      if (input.files) {
        let reader = new FileReader();
        reader.onload = (e) => {
          this.create.previewCarouselSmall = e.target.result;
        };
        this.create.imageCarouselSmall = input.files[0];
        reader.readAsDataURL(input.files[0]);
      }
      this.errors.carousel_small = false;
      this.errors.carousel_small_msg = "";
    },
    removeFileCarouselSmall: function() {
      this.create.previewCarouselSmall = null;
      this.create.imageCarouselSmall = null;
    },
    chooseLargeFile: function() {
      document.getElementById("carousel_file_large").click();
    },
    previewFileLarge: function(event) {
      let input = event.target;
      if (input.files) {
        let reader = new FileReader();
        reader.onload = (e) => {
          this.create.previewCarouselLarge = e.target.result;
        };
        this.create.imageCarouselLarge = input.files[0];
        reader.readAsDataURL(input.files[0]);
      }
      this.errors.carousel_large = false;
      this.errors.carousel_large_msg = "";
    },
    removeFileCarouselLarge: function() {
      this.create.previewCarouselLarge = null;
      this.create.imageCarouselLarge = null;
    },
    showModalCreate: function() {
      this.title = "Create New Facility";
      this.create = {
        title: "",
        description: "",
        previewCarouselSmall: null,
        imageCarouselSmall: null,
        previewCarouselLarge: null,
        imageCarouselLarge: null,
      };
      this.modalCreate = true;
    },
    closeModalCreate: function() {
      this.modalCreate = false;
    },
    findCarousels: async function() {
      try {
        let res = await fetch(`${API}v1/carousels`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });
        let respon = await res.json();
        if (respon.status !== 200) {
          this._error("internal server error");
          return;
        }
        this.rows = respon.data;
        this.totalRecordCount = respon.data.length;
      } catch (err) {
        this._error("internal server error");
      }
    },
    saveCarousel: async function() {
      this.saveButton = "Loading...";
      let formdata = new FormData();
      formdata.append("carousel_small", this.create.imageCarouselSmall);
      formdata.append("carousel_large", this.create.imageCarouselLarge);
      formdata.append("title", this.create.title);
      formdata.append("description", this.create.description);
      try {
        let res = await fetch(`${API}v1/admin/cms/carousel/store`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
          body: formdata,
        });
        const response = await res.json();
        if (response.status !== 200) {
          if (response.message === "ERR_FORM") {
            response.data.map((item) => {
              if (item.key === "carousel_small") {
                this.errors.carousel_small = true;
                this.errors.carousel_small_msg = item.message;
              }
              if (item.key === "carousel_large") {
                this.errors.carousel_large = true;
                this.errors.carousel_large_msg = item.message;
              }
              if (item.key === "title") {
                this.errors.title = true;
                this.errors.title_msg = item.message;
              }
              if (item.key === "description") {
                this.errors.description = true;
                this.errors.description_msg = item.message;
              }
            });
            this.saveButton = "Save";
            return;
          }
          this.modalCreate = false;
          this.saveButton = "Save";
          this._error(response.message);
          return;
        }
        this.modalCreate = false;
        this.saveButton = "save";
        this.findCarousels();
        this._success("Data has been saved.");
      } catch (err) {
        this.saveButton = "save";
        this._error("internal server error");
      }
    },
    _error: function(message) {
      this.$store.dispatch("warning", {
        isError: true,
        message: message,
      });
      setTimeout(() => {
        this.$store.dispatch("warning", {
          isError: false,
          message: "",
        });
      }, 5000);
    },
    _success: function(message) {
      this.$store.dispatch("success", {
        isSuccess: true,
        message: message,
      });
      setTimeout(() => {
        this.$store.dispatch("success", {
          isSuccess: false,
          message: "",
        });
      }, 5000);
    },
  },
  created: function() {
    this.findCarousels();
  },
};
</script>

<style scoped></style>
